import {
  File,
  Person,
  Shot,
  WildcardFiller,
  ClipSelection,
} from '../../../types';
import { isEmpty, msecToSec } from '../../../utils';

// clip selections – find the matching clips for each person's wildcard spot
export const getClipSelections = (props: {
  people: Person[];
  requiredShots: Shot[];
  isIncludeDuration?: boolean;
}): ClipSelection[] => {
  const { people, requiredShots, isIncludeDuration } = props;

  if (isEmpty(requiredShots) || isEmpty(people)) return [];

  const clipSelectionsUpd: ClipSelection[] = [];

  // for each face person – find the selected clips
  people.forEach((person) => {
    const faceId = person.face.elementId || null;

    if (!faceId) return;

    const selectionsObj: ClipSelection = {
      faceId,
      wildcardsFiller: requiredShots.map((shot) => ({
        wildCardShotIndex: shot.shotIndex,
        clipId: null,
        duration: shot.duration,
      })),
    };

    const checkedClips: string[] = [];

    // find matching clips
    selectionsObj.wildcardsFiller.forEach((w: WildcardFiller) => {
      // if wildcard has NO selected clip –  – find if there's matching one
      if (!w.clipId) {
        // find the first clip with highest ranking score that matches the wildcard spot
        const matchingClip = person.clips?.find(
          (clip: File) =>
            !checkedClips.includes(clip.elementId ?? '') &&
            msecToSec(clip.segment?.durationMilliseconds) >= (w.duration ?? 0),
        );

        if (matchingClip) w.clipId = matchingClip.elementId ?? '';
        if (!isIncludeDuration) delete w.duration;
      }

      // if wildcard has selected clip – check if it still exists (in case selects were deleted)
      else if (
        w.clipId &&
        !person.clips?.find((clip) => w.clipId === clip.elementId)
      )
        w.clipId = null;

      // update array of checked clips ids
      if (w.clipId) checkedClips.push(w.clipId);
    });

    clipSelectionsUpd.push(selectionsObj);
  });

  return clipSelectionsUpd;
};

export const getPersonWildcardsData = (
  faceId: string,
  requiredShots: Shot[],
  clipSelections: ClipSelection[],
) => {
  const missingClips: Shot[] = [];

  const selectedClips =
    clipSelections.find((s) => s.faceId === faceId)?.wildcardsFiller ?? [];

  selectedClips.forEach((clip) => {
    if (!clip.clipId) {
      const missingClip = requiredShots.find(
        (shot) => shot.shotIndex === clip.wildCardShotIndex,
      );
      if (missingClip) missingClips.push(missingClip);
    }
  });

  return { selectedClips, missingClips, isEnoughClips: isEmpty(missingClips) };
};
